import { IRootState } from '../../../store'
import { IWoundCareOptionsState } from '../store/options.types'

export const getWoundCareOptionsSelector = (state: IRootState): IWoundCareOptionsState => state.options.woundCareOptions
